var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFastFa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 16,
    viewBox: "0 0 31 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hinava_random_uuid_34253506666714733095588085800488139720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4812 12.287C12.3076 12.2849 12.1525 12.2719 12.0159 12.2487C11.8692 12.2232 11.7369 12.1865 11.6189 12.1387C11.5041 12.0941 11.4005 12.0399 11.308 11.9761C11.2188 11.9091 11.1343 11.8358 11.0546 11.7561C10.9079 11.8549 10.7612 11.9378 10.6146 12.0048C10.4679 12.0749 10.3149 12.1307 10.1554 12.1722C9.99601 12.2136 9.82862 12.2423 9.65326 12.2583C9.48109 12.2774 9.29457 12.287 9.0937 12.287C8.67601 12.287 8.2663 12.2072 7.86456 12.0478C7.46601 11.8884 7.09616 11.6317 6.755 11.2778L7.62065 10.0583C7.77688 10.2017 7.92833 10.3197 8.075 10.4122C8.22167 10.5015 8.36196 10.5716 8.49587 10.6226C8.62978 10.6736 8.75572 10.7087 8.8737 10.7278C8.99485 10.747 9.10804 10.7565 9.21326 10.7565C9.29935 10.7565 9.39181 10.7517 9.49065 10.7422C9.58949 10.7294 9.68674 10.7103 9.78239 10.6848C9.88123 10.6593 9.9737 10.6274 10.0598 10.5891C10.1459 10.5509 10.2208 10.503 10.2846 10.4457C10.1634 10.1523 10.0311 9.84783 9.88761 9.53218C9.74732 9.21334 9.60544 8.89449 9.46196 8.57565C9.31848 8.25362 9.17659 7.93478 9.0363 7.61913C8.89601 7.30348 8.76529 7.00058 8.64413 6.71044L10.0407 6.12696L11.6189 9.9387C11.6763 10.079 11.7289 10.2017 11.7767 10.307C11.8246 10.4122 11.8804 10.4999 11.9441 10.57C12.0111 10.6401 12.0892 10.6928 12.1785 10.7278C12.2709 10.7597 12.3889 10.7757 12.5324 10.7757H16.998C17.438 10.7757 17.7696 10.7039 17.9928 10.5604C18.216 10.417 18.3276 10.2017 18.3276 9.91478C18.3276 9.81913 18.3149 9.68522 18.2893 9.51304C18.2638 9.33768 18.2112 9.10812 18.1315 8.82435L19.485 8.49435C19.536 8.66971 19.5775 8.82594 19.6093 8.96305C19.6444 9.09696 19.6715 9.21971 19.6906 9.33131C19.7098 9.4429 19.7241 9.54652 19.7337 9.64218C19.7433 9.73464 19.7512 9.82551 19.7576 9.91478C19.764 10.0041 19.7735 10.0997 19.7863 10.2017C19.7991 10.3006 19.823 10.393 19.858 10.4791C19.8963 10.5652 19.9473 10.637 20.0111 10.6943C20.078 10.7486 20.1673 10.7757 20.2789 10.7757H21.342C21.4791 10.7757 21.6305 10.7693 21.7963 10.7565C21.9621 10.7406 22.1167 10.7103 22.2602 10.6657C22.4069 10.621 22.528 10.5557 22.6237 10.4696C22.7225 10.3803 22.772 10.2639 22.772 10.1204C22.772 10.0439 22.748 9.93073 22.7002 9.78087C22.6556 9.62783 22.595 9.45884 22.5185 9.27391C22.4451 9.0858 22.3607 8.88971 22.265 8.68565C22.1725 8.4816 22.0801 8.2871 21.9876 8.10217L23.3554 7.42304C23.4447 7.62391 23.5324 7.83754 23.6185 8.06391C23.7078 8.29029 23.7875 8.51986 23.8576 8.75261C23.9278 8.98536 23.9836 9.21812 24.025 9.45087C24.0696 9.68044 24.092 9.90044 24.092 10.1109C24.092 10.5062 24.0186 10.8426 23.872 11.12C23.7285 11.3942 23.5324 11.619 23.2837 11.7943C23.035 11.9665 22.7433 12.0909 22.4085 12.1674C22.0737 12.2471 21.715 12.287 21.3324 12.287H12.4812Z",
    fill: "url(#hinava_random_uuid_252806492170239951668360902721259933328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5237 6.74391L22.4228 5.84478L23.3315 6.75348L24.2498 5.83044L23.322 4.90739L22.4228 5.80652L21.5141 4.89783L20.5959 5.82087L21.5237 6.74391Z",
    fill: "url(#hinava_random_uuid_128605168837217666545458009130067327238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.342 7.72913L17.2802 6.66739L18.342 5.60565L19.4037 6.66739L18.342 7.72913Z",
    fill: "url(#hinava_random_uuid_287555832513542952729307943723874774224)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 3.5C0.5 1.567 2.067 0 4 0H27C28.933 0 30.5 1.567 30.5 3.5V12.5C30.5 14.433 28.933 16 27 16H4C2.067 16 0.5 14.433 0.5 12.5V3.5ZM4 1H27C28.3807 1 29.5 2.11929 29.5 3.5V12.5C29.5 13.8807 28.3807 15 27 15H4C2.61929 15 1.5 13.8807 1.5 12.5V3.5C1.5 2.11929 2.61929 1 4 1Z",
    fill: "url(#hinava_random_uuid_276466653178328570862331771342033111784)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_252806492170239951668360902721259933328",
    x1: 18.6915,
    y1: 5.25536,
    x2: 18.6915,
    y2: 14.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_128605168837217666545458009130067327238",
    x1: 18.6915,
    y1: 5.25536,
    x2: 18.6915,
    y2: 14.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_287555832513542952729307943723874774224",
    x1: 18.6915,
    y1: 5.25536,
    x2: 18.6915,
    y2: 14.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_276466653178328570862331771342033111784",
    x1: 18.6915,
    y1: 5.25536,
    x2: 18.6915,
    y2: 14.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hinava_random_uuid_34253506666714733095588085800488139720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastFa);
export default __webpack_public_path__ + "static/media/fast-fa.be074085cbc0c78778553c0db4d10c4e.svg";
export { ForwardRef as ReactComponent };